import {
  Pagination,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Typography,
} from '@occc/ui-design-system';

import { LocationActivity } from './location-activity.component';

import { LocationActivityListProps } from '../types';

const LocationActivityList = ({
  data,
  paginationProps,
  onRequestDetailsView,
  timezone,
  loading,
}: LocationActivityListProps) => {
  if (loading && !data?.length) {
    return <Typography p={2}>Loading...</Typography>;
  }

  if (!loading && !data?.length) {
    return <Typography p={2}>No activity log messages available</Typography>;
  }

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Timestamp</TableCell>
            <TableCell>Message Type</TableCell>
            <TableCell>Member ID</TableCell>
            <TableCell>UMTI</TableCell>
            <TableCell width={64} align='center'>
              Message
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {data?.map((node) => (
            <LocationActivity
              key={node.createdAt}
              title={node.description}
              rawMessage={node.rawMessage}
              onRequestDetailsView={onRequestDetailsView}
              timestamp={node.createdAt}
              timezone={timezone}
            />
          ))}
        </TableBody>
      </Table>
      <Pagination {...paginationProps} />
    </>
  );
};

export default LocationActivityList;
